import React, {useMemo} from 'react';

import {AiAssistUsageView} from 'src/modules/admin/ai-assist-usage/ai-assist-usage.view';
import {useAllAiReviewUsageBasicInfo} from 'src/modules/admin/ai-assist-usage/hooks/useAllAiReviewUsageBasicInfo';
import {UsersInfoController} from 'src/modules/users-info/users-info.controller';

export const AiAssistUsageController = () => {
    const {aiAssistData, isLoading} = useAllAiReviewUsageBasicInfo();
    const authorsEmails = useMemo(() => {
        return [...new Set(aiAssistData.map(data => data.authorEmail))];
    }, [aiAssistData]);

    return (
        <>
            <UsersInfoController emails={authorsEmails}/>
            <AiAssistUsageView
                aiReviewUsageBasicInfo={aiAssistData}
                isLoading={isLoading}
            />
        </>
    );
};
